import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ROLES = [
    { v: "developer", l: "Developer" },
    { v: "node_operator", l: "Node Operator" },
    { v: "investor", l: "Investor" },
    { v: "partner", l: "Partner" },
];

export default function WaitlistForm() {
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("developer");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!email || !email.includes("@")) {
            toast.error("Enter a valid email");
            return;
        }
        setLoading(true);
        try {
            await axios.post(`${API}/waitlist`, { email, role, source: "landing" });
            setDone(true);
            toast.success("You're on the list. Welcome to DeCloudX.");
            setEmail("");
        } catch (err) {
            const msg = err?.response?.data?.detail || "Something went wrong. Try again.";
            toast.error(typeof msg === "string" ? msg : "Submission failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={onSubmit} className="w-full max-w-2xl mx-auto" data-testid="waitlist-form">
            <div className="surface-strong rounded-2xl p-2 flex flex-col md:flex-row md:items-center gap-2">
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@protocol.dev"
                    className="flex-1 bg-transparent px-5 py-4 text-ink placeholder:text-faint-ink focus:outline-none font-mono text-sm"
                    data-testid="waitlist-email"
                />
                <select
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                    className="bg-transparent border-l border-line px-4 py-4 text-ink focus:outline-none font-mono text-xs uppercase tracking-wider"
                    data-testid="waitlist-role"
                >
                    {ROLES.map((r) => (
                        <option key={r.v} value={r.v}>{r.l}</option>
                    ))}
                </select>
                <button
                    type="submit"
                    disabled={loading || done}
                    className="btn-primary disabled:opacity-60 disabled:hover:scale-100 justify-center"
                    data-testid="waitlist-submit"
                >
                    {loading ? <Loader2 size={16} className="animate-spin" /> : done ? "On the list" : (<>Reserve Spot <ArrowRight size={15} strokeWidth={2} /></>)}
                </button>
            </div>
            <p className="mt-3 text-center font-mono text-[10px] uppercase tracking-[0.18em] text-faint-ink">
                No spam · Early access to mainnet, testnet incentives, and node onboarding.
            </p>
        </form>
    );
}
